export default __webpack_public_path__ + "static/inventoryStockManagementVp1-25bf4ce4e8c0be20968b4cf610ae09f2.png";